import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/JacForklift-eShop/src/app/components/Cattegory.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/JacForklift-eShop/src/app/components/Footer.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/JacForklift-eShop/src/app/components/Header.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/JacForklift-eShop/src/app/components/Products.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/var/www/JacForklift-eShop/src/app/contexts/LanguageContext.jsx");
